import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {ReelsCascadingModule, ReelsCascadingStates, ReelsCascadingView} from '@gongxigames/framework/slot/modules/reelsCascading';

export class ReelsCascadingInitState extends ModuleState<ReelsCascadingView, ReelsCascadingModule> {
    public onEnterState(): void {
        this.module.restoreSymbols(this.module.initialStopPositions);
        this.goToBasicState();
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
    }

    protected goToBasicState(): void {
        this.module.gotoState(ReelsCascadingStates.BASIC_STATE);
    }
}